import { render, staticRenderFns } from "./FormGrid.vue?vue&type=template&id=08fd1277"
import script from "./FormGrid.vue?vue&type=script&lang=js"
export * from "./FormGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports